import { Button, Modal, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../../../../Assets/icons";
import success from "../../../../Assets/successGraphic.png";
import "./index.css";

interface FeedbackModalProps {
  modalClose: () => void;
  message: string;
  action: () => void;
  actionButtonText: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  modalClose,
  action,
  actionButtonText,
  message,
}) => {
  const [visible, setVisibile] = useState(true);
  const closeModal = () => {
    setVisibile(false);
    modalClose();
  };
  const { t } = useTranslation();
  return (
    <Modal
      className="feedbackModal"
      open={visible}
      onCancel={closeModal}
      footer={null}
      closeIcon={<CloseIcon />}
    >
      <Typography.Text className="congratulations">
        {t("Congratulations!")}
      </Typography.Text>
      <img className="successImage" src={success} alt="" />
      <Typography.Text className="successMessage">{message}</Typography.Text>
      <Button
        onClick={action}
        className="commonButtonBackground primaryButton feedbackActionButton"
      >
        {actionButtonText}
      </Button>
    </Modal>
  );
};

export default FeedbackModal;
